import React, {FC, useEffect, useState} from "react";
import ButtonPrimary from "components/Button/ButtonPrimary";
import Input from "components/Input/Input";
import Label from "components/Label/Label";
import LayoutPage from "components/LayoutPage/LayoutPage";
import Textarea from "components/Textarea/Textarea";
import {Helmet} from "react-helmet";
import emailjs from '@emailjs/browser';
import {addDoc, collection, doc, getDoc, serverTimestamp} from "firebase/firestore";
import {auth, db} from "../../configs/firebase-config";
import BgGlassmorphism from "../../components/BgGlassmorphism/BgGlassmorphism";
import SectionSubscribe2 from "../../components/SectionSubscribe2/SectionSubscribe2";
import {displayToast, toastType} from "../../global/Functions";


export interface PageContactProps {
  className?: string;
}


const PageContact: FC<PageContactProps> = ({className = ""}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [popUpMessage, setPopUpMessage] = useState("");

  const contactFormCollectionRef = collection(db, "contact-form");

  useEffect(() => {
    if (auth.currentUser){
      getDoc(doc(db, "users", `${auth.currentUser?.uid}`)).then((result) => {
        setName(`${result.get("firstName")} ${result.get("lastName")}`);
        setEmail(result.get("email"));
      })
    }
  }, [])

  const processContactForm = async (e: any) => {
    e.preventDefault();

    try {
      await addDoc(contactFormCollectionRef, {
        name,
        email,
        message,
        time: serverTimestamp()
      });

      displayToast("Message sent. Our team will get back to you as soon as possible", toastType.success);
    } catch (error) {
      displayToast("Something went wrong", toastType.error);
    }

    emailjs.sendForm('service_yklfd0i', 'template_kmllxcy', e.target, 'user_Y42cWwZi6lpaoh6FhJy9n')
      .then((result) => {
        console.log(result.text);
/*        setPopUpMessage("Your message has been sent.");
        setTimeout(() => { setPopUpMessage("") }, 5000);*/
        e.target.reset();
      }, (error) => {
        console.log(error.text);
      });
  };

  return (
    <div className={`PageContact ${className}`} data-id="PageContact">
      <Helmet>
        <title>Contact | CryptoVerse</title>
      </Helmet>
      <BgGlassmorphism/>
      <LayoutPage
        subHeading="Can't find what you're looking for? Get in touch!"
        headingEmoji=""
        heading="Contact us"
      >
        <div className=" justify-grid gap-8 lg:grid-cols-2">

          <div className="border border-neutral-100 dark:border-neutral-700 lg:hidden"/>
          <div>
            <form className="grid grid-cols-1 gap-6" onSubmit={processContactForm}>
              <label className="block">
                <Label>Full name</Label>
                <Input
                  placeholder="Name"
                  type="text"
                  defaultValue={name}
                  className="mt-1"
                  name="firstName"
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </label>
              <label className="block">
                <Label>Email address</Label>

                <Input
                  type="email"
                  defaultValue={email}
                  placeholder="name@example.com"
                  className="mt-1"
                  name="email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </label>
              <label className="block">
                <Label>Message</Label>

                <Textarea className="mt-1" rows={6} name="message" placeholder="What can we help you with?"
                          onChange={(e) => setMessage(e.target.value)} required/>
              </label>
              <ButtonPrimary type="submit">Send Message</ButtonPrimary>
            </form>
            {/*TODO: STYLE FOLLOWING*/}
            {popUpMessage &&
              <div className="contact-form-pop-up" style={{background: "indigo"}}>Your message has been
                sent.</div>}
          </div>
        </div>
      </LayoutPage>
      <div className="container ">
        <SectionSubscribe2 className="pt-16 lg:pt-28"
        />
      </div>
    </div>
  );
};

export default PageContact;
